import { render, staticRenderFns } from "./MoveEdit.vue?vue&type=template&id=0621f36d"
import script from "./MoveEdit.vue?vue&type=script&lang=js"
export * from "./MoveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports